// Regular prices written as a multi-buy, and which capture holds the item count
// and which the price paid for that many. goflyer-server reads them with the
// same patterns (src/common/utils/price), so Calculate Save agrees with the
// discounts shoppers see.
const MULTI_BUY_REGULAR_PRICE_FORMATS = [
  // "3 for 3.99", "2 for $5.00", "2/$15.23", "5/2.00"
  { regex: /^(\d+)\s*(for|\/)\s*\$?\s*(\d+(\.\d+)?)$/i, count: 1, price: 3 },
  // "$5/2", "$5 for 2"
  {
    regex: /^\$\s*(\d+(\.\d+)?)\s*(for|\/)\s*(\d+)\s*(pcs?)?$/i,
    count: 4,
    price: 1,
  },
  // "12.99 for 12", "3.99/3pcs"
  { regex: /^(\d+\.\d+)\s*(for|\/)\s*(\d+)\s*(pcs?)?$/i, count: 3, price: 1 },
] as const;

/**
 * The regular price of one item, read from the free-text regular price; 0 when
 * none can be read.
 *
 * - A single price is read as written: "15.23", "$15.23", "5.99/ea", "12.50/lb".
 * - A multi-buy is divided by its count: "3 for 3.99" and "2/$7.98" are $1.33
 *   and $3.99 each. Reading them as one number would glue the digits together
 *   ("3 for 3.99" → 33.99) or price two items as one.
 */
export function parseRegularPricePerUnit(regularPriceString: string): number {
  const text = regularPriceString.trim();
  for (const { regex, count, price } of MULTI_BUY_REGULAR_PRICE_FORMATS) {
    const match = regex.exec(text);
    if (match) {
      const itemCount = Number(match[count]);
      return itemCount > 0 ? Number(match[price]) / itemCount : 0;
    }
  }

  let numericValue = "";
  const dollarIndex = regularPriceString.lastIndexOf("$");
  if (dollarIndex !== -1) {
    numericValue = regularPriceString.substring(dollarIndex + 1);
  } else {
    numericValue = regularPriceString.replace(/[^0-9.]/g, "");
  }
  const parts = numericValue.split(".");
  numericValue = parts[0] + (parts.length > 1 ? "." + parts[1] : "");
  return parseFloat(numericValue || "0");
}
